module.exports = __webpack_public_path__ + "assets/img/306401.9982e93f.png";